import { Header } from "@/components/Header";
import { RocFrameworkExperience, frameworkPhases } from "@/components/methodology/RocFrameworkExperience";
import { MethodologyEditorial } from "@/components/methodology/MethodologyEditorial";
import { Footer } from "@/components/Footer";
import { SEOWrapper } from "@/components/SEOWrapper";
import { usePageSeo } from "@/hooks/usePageSeo";

const MethodologyPage = () => {
  const { language, url, esUrl, enUrl, onLanguageChange } = usePageSeo();

  const meta = {
    es: {
      title: "Metodología de Trabajo - Luis ROC Consultor SEO",
      description: "El ROC Search Growth Framework: cómo se prioriza, ejecuta y mide el trabajo de SEO paso a paso, sin promesas de resultados.",
      summary: "Explicación del ROC Search Growth Framework: siete fases (investigación, base técnica, intención de búsqueda, autoridad, visibilidad, conversión y medición), cómo se priorizan las iniciativas por impacto, esfuerzo y evidencia, y cómo la medición retroalimenta la investigación, sin garantizar resultados.",
      keyPoints: [
        "Marco de priorización por impacto, esfuerzo y evidencia",
        "Siete fases: investigación, base técnica, intención, autoridad, visibilidad, conversión y medición",
        "La medición retroalimenta la investigación como ciclo continuo",
        "Errores comunes que el marco busca evitar",
        "Medición basada en línea base específica del sitio, sin resultados garantizados",
      ],
    },
    en: {
      title: "Work Methodology - Luis ROC SEO Consultant",
      description: "The ROC Search Growth Framework: how SEO work is prioritized, executed and measured step by step, with no promised outcomes.",
      summary: "An explanation of the ROC Search Growth Framework: seven phases (research, technical foundation, search intent, authority, search visibility, conversion and measurement), how initiatives are prioritized by impact, effort and evidence, and how measurement feeds back into research, without guaranteeing results.",
      keyPoints: [
        "Prioritization framework based on impact, effort and evidence",
        "Seven phases: research, technical foundation, search intent, authority, search visibility, conversion and measurement",
        "Measurement feeds back into research as a continuous cycle",
        "Common mistakes the framework is designed to avoid",
        "Measurement against a site-specific baseline, with no guaranteed outcomes",
      ],
    }
  };

  const currentMeta = meta[language];

  return (
    <SEOWrapper
      title={currentMeta.title}
      description={currentMeta.description}
      url={url}
      esUrl={esUrl}
      enUrl={enUrl}
      language={language}
      pageType="article"
      structuredData={{
        type: 'howto',
        data: {
          name: currentMeta.title,
          description: currentMeta.description,
          steps: frameworkPhases[language].map((phase) => ({
            name: phase.title,
            description: phase.description,
          })),
        }
      }}
      summary={currentMeta.summary}
      keyPoints={currentMeta.keyPoints}
    >
      <div className="min-h-screen bg-background">
        <Header language={language} onLanguageChange={onLanguageChange} />
        
        <main>
          <RocFrameworkExperience language={language} />
          <MethodologyEditorial language={language} />
        </main>
        
        <Footer language={language} />
      </div>
    </SEOWrapper>
  );
};

export default MethodologyPage;
